import {
  MdAgriculture, MdGrain, MdSpa, MdEco, MdNature, MdLocalFlorist
} from 'react-icons/md';
import { GiWheat, GiCorn, GiSunflower, GiBeanstalk } from 'react-icons/gi';
import { FaLeaf, FaSeedling } from 'react-icons/fa';

// The panel's product icon set, copied from the kiosk ui's
// components/common/ProductIcon.jsx so the admin shows the same picture the
// operator picked on the touchscreen. The name arrives on the stream as
// activeProduct.icon.
const PRODUCT_ICONS = {
  corn: { Icon: GiCorn, color: '#FFD700' },
  wheat: { Icon: GiWheat, color: '#D2691E' },
  rice: { Icon: MdSpa, color: '#F5DEB3' },
  soybeans: { Icon: FaSeedling, color: '#8B7355' },
  soybean: { Icon: FaSeedling, color: '#8B7355' },
  beans: { Icon: GiBeanstalk, color: '#654321' },
  sunflower: { Icon: GiSunflower, color: '#FFB90F' },
  barley: { Icon: MdAgriculture, color: '#8B7D6B' },
  oats: { Icon: MdGrain, color: '#CDAA7D' },
  canola: { Icon: MdLocalFlorist, color: '#FFD700' },
  peas: { Icon: MdEco, color: '#228B22' },
  lentils: { Icon: FaLeaf, color: '#CD853F' },
  alfalfa: { Icon: MdNature, color: '#32CD32' },
  grain: { Icon: MdGrain, color: '#8B8878' },
};

// Unknown or missing names fall back to the generic grain picture, which is
// what the panel does too.
export const getProductIcon = (name) => PRODUCT_ICONS[name] || PRODUCT_ICONS.grain;
